import { render } from "./Header.vue?vue&type=template&id=c37dfa46"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c37dfa46&lang=css"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__